export default __webpack_public_path__ + "static/media/cm-3.e0de04b6.jpg";